import styled, { css } from 'styled-components';
import { ITopRowStyle } from './types';

export const LOGO_HEIGHT = 150;
export const LOGO_LEFT = 50;
export const Container = styled.div`
    position: relative;
    background-color: ${p => p.theme.c.snow};
    padding-bottom: 16px;
`;

export const COVER_IMAGE_HEIGHT = 360;

export const CoverImage = styled.div`
    height: ${COVER_IMAGE_HEIGHT}px;
    background-size: cover;
    background-position: center center;
`;

export const ChoirName = styled.h3`
    margin: 0;
`;
export const FoundedDate = styled.p`
    margin: 8px 0;
    font-size: 14px;
    ${p => p.theme.xs(css`
        text-align: center;
    `)}
`;

export const StatusFlag = styled.div`
    background-color: ${p => p.theme.c.info};
    color: ${p => p.theme.c.dark};
    padding: 4px 6px;
    border-radius: 4px;
    
    ${p => p.theme.sm.min(css`
        margin-left: 16px;
    `)}
`;

export const TopRow = styled.div<ITopRowStyle>`
    margin-left: ${p => (p.hasLogo ? (LOGO_LEFT + LOGO_HEIGHT) : 32) + 16}px;

    display: flex;
    padding-right: 48px;
    justify-content: space-between;
    align-items: center;
    button {
        margin-bottom: 0;
        width: 200px;
    }

    ${p => p.theme.xs(css`
        margin-left: 0;
        flex-direction: column;
        margin-top: ${LOGO_HEIGHT / 2}px;    
        padding-right: 0;
    `)}

`;

export const Column = styled.div`
    flex: 1;
`;

export const TitleRow = styled.div`
    display: flex;
    margin-top: 16px;
    margin-bottom: 8px;
    align-items: center;
    ${p => p.theme.xs(css`
        padding: 0 16px;
        flex-wrap: wrap;
        justify-content: center;
        gap: 12px;
    `)}
`;
export const Padding = styled.div`
    padding: 4px 48px;
    display: flex;
    gap: 24px;
    ${p => p.theme.xs(css`
        padding: 4px 16px;
        flex-direction: column;
    `)}
`;

export const TopRowLeft = styled.div`
    min-height: 78px;
`;
export const TopRowRight = styled.div`
    ${p => p.theme.xs(css`
        display: none;
    `)}
`;

export const MobileApply = styled.div`
    button {
        display: block;
        margin: auto;
        width: 160px;   
    }
    ${p => p.theme.sm.min(css`
        display: none;
    `)}
`;